import type { SVGProps } from "react";

export function IconBlueWaveArrowUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M49 38.5V39C49 45.0751 44.0751 50 38 50V50C31.9249 50 27 45.0751 27 39V32V25C27 18.9249 22.0751 14 16 14V14C9.92487 14 5 18.9249 5 25V31.5"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M40 37L49 27L58 37H40Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
